import React, {Fragment, useEffect} from 'react';
import { BackTop } from 'antd';
import { useLocation } from "react-router-dom";

const SiteLayout = ( props ) => {
    const location = useLocation();
    const contentStyle = !props?.noStyle && (props?.styleMarket ? props?.styleMarket : "master-layout__content");

   return (
        <Fragment>
            {props?.noLayout ? props.children : <div className="master-layout">
                <div className={contentStyle}>
                    {props.children}
                </div>
            </div> }
            <BackTop />
            
        </Fragment>
    )
};
export default SiteLayout;

export const getLayout = page => <SiteLayout>{ page }</SiteLayout>
